export const fmtNum = (v, digits = 2) => {
  const n = Number(v ?? 0);
  if (!isFinite(n)) return "0";
  return n.toLocaleString("en-IN", { minimumFractionDigits: digits, maximumFractionDigits: digits });
};

export const fmtQty = (v) => fmtNum(v, Math.abs(Number(v ?? 0)) < 10 ? 2 : 0);

export const fmtMoney = (v) => {
  const n = Number(v ?? 0);
  const abs = Math.abs(n);
  if (abs >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  return `₹${fmtNum(n, 0)}`;
};

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" }) : "—");

export const today = () => new Date().toISOString().slice(0, 10);
